import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionButtonAPICallRequest, resetActionButtonAPICall } from '../../case-summary-one-view/store/actionButtonApiCall.slice';
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';

interface ApiConfig {
  actionType: string;
  payload?: any;
  successCallback?: (data: any) => void;
  errorCallback?: (error: any) => void;
}

interface ActionButtonProps {
  label: string;
  data?: any;
  fileName?: string;
  onClick?: (res:any) => void;
  payload?: any;
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  token?: any;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  data,
  fileName,
  onClick,
  payload,
  disabled = false,
  className = '',
  type = 'button',
  token = null
}) => {
  const dispatch = useDispatch();

  const actionButtonData = useSelector((state: any) => state.actionButtonData);
  
  useEffect(() => {
    if (actionButtonData.isSuccess && actionButtonData.data.data !== null) {

      const fName = actionButtonData.data.headers['content-disposition'].split("; ")[1].replace("filename=", "") || fileName || 'download.pdf';
      saveAs(new Blob([actionButtonData.data.data], { type: 'application/pdf' }), fName);

      dispatch(resetActionButtonAPICall());
    } else if (actionButtonData.isError) {
      toast.error(`Error: ${actionButtonData.error.message || 'An error occurred'}`);
      // Handle error if needed
      dispatch(resetActionButtonAPICall());
    }
  }, [actionButtonData, onClick]);


  const handleClick = async () => {
    // download text 
    window.confirm('By exporting this PDF, you will be downloading this information from OneView. If you do not need to download this information, please close this window. If you need to download this information, please click OK') && handleClickStart();
  }

  const handleClickStart = async () => {
    // Execute custom onClick if provided
    if (onClick) {
      onClick(payload);
    }
    
    // Dispatch Redux action if apiConfig is provided
    if (data) {
      const params:any = {}
      
      data.apiParameters.map((res:any)=> {
        params[res] = payload[res]
      });

      const actionPayload:any = {
        token: token,
        url: data.apiEndpoint.replace("/api", ""),
        param: {
          ...params
        }
      }

      
      dispatch(actionButtonAPICallRequest(actionPayload));
    }

  };

  const isButtonDisabled = disabled || actionButtonData.isFetching;

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={isButtonDisabled}
      className={`action-button ${className} ${isButtonDisabled ? 'disabled' : ''}`}
    >
      {(actionButtonData.isFetching) ? 'Downloading...' : label}
    </button>
  );
};

export default ActionButton;